import { currencyMapping, ISOCurrency } from "../currency";
import { isNil } from "lodash-es";

export const toIsoCurrency = (currency?: string): string => {
  if (isNil(currency)) {
    return "unknown";
  }
  if (currency in ISOCurrency) {
    return currency;
  }

  // Fallback
  return currencyMapping[currency] ?? "unknown";
};

export const toIsoCurrencySymbol = (currency?: string): string | undefined => {
  const isoCurrency = toIsoCurrency(currency);
  return ISOCurrency[isoCurrency].symbol;
};
